import React from 'react';

const NotFoundPage = () => {
  return (
    <div className='container text-center mt-4'>
      <h1>404 - Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFoundPage;
